import { gql } from "@apollo/client";

export const calculatePayBillMutation = gql`
mutation($input: PayBillInput!){
  calculatePayBill(input: $input) {
    message
    response
  }
}
`;